import NiceModal, { useModal } from '@ebay/nice-modal-react'
import { useTranslation } from 'react-i18next'
import { Portal } from 'react-portal'

import pwaStepsGif from '../../assets/pwa-steps/pwa-steps.gif'
import classNames from '../../utils/classNames'
import closeModal from '../../utils/closeModal'
import Backdrop from './backdrop'

const STEP_KEYS = [
  'ios-step-1',
  'ios-step-2',
  'ios-step-3',
  'ios-step-4',
] as const

const PwaDownloadStepsModal = ({
  onConfirm,
}: {
  onConfirm?: () => void
}) => {
  const modal = useModal()
  const { t } = useTranslation('downloadPwa')

  const handleClose = () => {
    onConfirm?.()
    closeModal(modal)
  }

  return (
    <Portal>
      <Backdrop
        id="pwa-download-steps-backdrop"
        isVisible={modal.visible}
        zIndex={203}
        onClick={handleClose}
      />
      <div
        className={classNames(
          'fixed bottom-0 left-0 right-0 z-[204] bg-primary rounded-t-2xl transition-transform duration-300 ease-in-out max-h-[85vh] overflow-y-auto',
          modal.visible ? 'translate-y-0' : 'translate-y-full',
        )}>
        {/* Drag handle */}
        <div className="flex justify-center pt-3 pb-2">
          <div className="w-10 h-1 rounded-full bg-secondary-txt/30" />
        </div>

        <div className="px-6 pb-6">
          {/* Title */}
          <h3 className="font-bold text-xl text-txt text-center mb-5">
            {t('title')}
          </h3>

          <div className="flex justify-center mb-5 rounded-xl overflow-hidden">
            <img className="w-full" src={pwaStepsGif} alt="PWA install steps" />
          </div>

          {/* Steps */}
          <div className="flex flex-col gap-4 mb-6">
            {STEP_KEYS.map((key, i) => (
              <div key={key} className="flex items-center gap-3">
                <span className="flex-shrink-0 w-7 h-7 rounded-full bg-highlight text-primary-btn-txt flex items-center justify-center text-sm font-bold">
                  {i + 1}
                </span>
                <span className="text-sm text-txt">{t(key)}</span>
              </div>
            ))}
          </div>

          {/* Close button */}
          <button
            className="w-full py-3 rounded-lg bg-secondary text-txt text-base font-semibold uppercase"
            onClick={handleClose}>
            {t('close')}
          </button>
        </div>
      </div>
    </Portal>
  )
}

export default NiceModal.create(PwaDownloadStepsModal)
